import {Utility} from "../core/utility";

export const errorHandler = {

    errors: [],

    /**
     * Will log a new system error
     * @param {{label: String, message: String}} error
     * @constructor
     */
    New: (error) => {
        if (false) errorHandler.errors.push(error); // disabling the error errorHandler
    },

    checkErrorLog: () => {
        // check if errors have been logged
        if (errorHandler.errors.length > 0) errorHandler.generateVisualErrorLog();
    },

    generateVisualErrorLog: () => {
        let ERRORS = '';
        errorHandler.errors.forEach(error => {
            if (window.$ActiveJS.visualErrors) {
                ERRORS += `
                <div class="error-line-wrapper">
                    <div class="error-label">${error.label}</div>
                    <div class="error-message">${error.message}</div>
                </div>`;
            }
            else {
                console.error(`${error.label} :: ${error.message}`);
            }
        });

        if (ERRORS !== '') errorHandler.RenderErrors(ERRORS);
    },

    /**
     * Builds up the css for the errors
     * @returns {string}
     */
    getVisualErrorsCSS: () => {
        return `
        <style>
            #activejs-errors-wrapper {
                display: flex;
                flex-direction: column;
                background-color: rgba(0, 0, 0, 0.7);
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
            }
            
            #activejs-errors-wrapper .error-line-wrapper {
                width: 100%;
                display: flex;
            }
            
            #activejs-errors-wrapper .error-line-wrapper .error-label {
                min-width: 20%;
                padding: 10px;
                color: #ffffff;
                font-size: 15px;
                font-weight: bolder;
                background-color: #da1039;
            }
            
            #activejs-errors-wrapper .error-line-wrapper .error-message {
                padding: 10px;
                color: #ffffff;
                font-size: 15px;
            }
        </style>`;
    },

    /**
     * Builds up all the error HTML
     * @param {String} Errors
     * @returns {Document}
     */
    getVisualErrorsHTML: (Errors) => {
        const htmlString = `
        ${errorHandler.getVisualErrorsCSS()}
        <div id="activejs-errors-wrapper">${Errors}</div>`;

        return htmlString;
    },

    RenderErrors: (ERRORS) => {
        const HTML = errorHandler.getVisualErrorsHTML(ERRORS);
        const el = document.getElementById(window.$ActiveJS.renderEl);
        if (el) el.innerHTML += HTML;
    },

};